import {useState} from 'react';

import {RedemptionCodeLookupForm} from '~/features/LunaClub/RewardCodeLookup/RedemptionCodeLookupForm';
import {RedemptionCollection} from '~/types';

export const RewardCodeLookup = () => {
  const [userData, setUserData] = useState<RedemptionCollection>();
  const findUserData = (userData: RedemptionCollection) => {
    setUserData(userData);
  };

  const [redemptionCode, setRedemptionCode] = useState('');
  const shareRedemptionCode = (code: string) => {
    setRedemptionCode(code);
  };

  return (
    <div className="p-5">
      <h1 className="text-5xl text-center font-semibold">Reward lookup</h1>
      <div className="flex flex-col justify-center items-center pt-5 gap-6">
        <div className="flex-row">
          <div className="flex flex-col">
            <p className="font-medium pb-2">
              Enter redemption code below to retrieve information
            </p>
            <RedemptionCodeLookupForm
              findUserData={findUserData}
              shareRedemptionCode={shareRedemptionCode}
            />
          </div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table table-zebra">
          <thead>
            <tr>
              <th>Redemption Code</th>
              <th>UserId</th>
              <th>Email</th>
              <th>Points total</th>
              <th>Reward Type</th>
              <th>Reward Level</th>
              <th>Achieved on</th>
            </tr>
          </thead>
          {userData && redemptionCode && userData[redemptionCode] && (
            <tbody>
              <tr>
                <th>{redemptionCode}</th>
                <td>{userData[redemptionCode].user?.userId}</td>
                <td>{userData[redemptionCode].user?.email}</td>
                <td>{userData[redemptionCode].user?.points}</td>
                <td>{userData[redemptionCode].reward?.rewardType}</td>
                <td>{userData[redemptionCode].reward?.level}</td>
                <td>
                  {userData[redemptionCode].reward?.achievedOn
                    ? new Date(
                        userData[redemptionCode].reward.achievedOn,
                      ).toString()
                    : ''}
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};
